/* eslint-disable class-methods-use-this */
import axios from "axios";

import {API_ANNOUNCEMENT_URL, COMMON_HEADER_CONFIG} from "../config";

class LanguageService {
  getAccessToken = () => localStorage.getItem("accessToken");

  searchLanguages = (data = {}) =>
    new Promise((resolve, reject) => {
      const config = {
        method: "get",
        url: `${API_ANNOUNCEMENT_URL}/language`,
        params: {
          size: 100,
          page: 1,
          ...data
        },
        headers: {
          ...COMMON_HEADER_CONFIG,
          Authorization: `Bearer ${this.getAccessToken()}`
        }
      };
      axios(config)
        .then((response) => {
          if (response.data.data && response.data.code === "success") {
            resolve(response.data);
          } else {
            reject(response);
          }
        })
        .catch((error) => {
          reject(error);
        });
    });

  getLanguages = () =>
    new Promise((resolve, reject) => {
      const config = {
        method: "get",
        url: `${API_ANNOUNCEMENT_URL}/language`,
        params: {
          size: 100,
          page: 1
        },
        headers: {
          ...COMMON_HEADER_CONFIG,
          Authorization: `Bearer ${this.getAccessToken()}`
        }
      };
      axios(config)
        .then((response) => {
          if (response.data.data) {
            resolve(response.data.data);
          } else {
            reject(response.data.data);
          }
        })
        .catch((error) => {
          reject(error);
        });
    });

  getOneLanguage = (id) =>
    new Promise((resolve, reject) => {
      const config = {
        method: "get",
        url: `${API_ANNOUNCEMENT_URL}/language/${id}`,
        headers: {
          ...COMMON_HEADER_CONFIG,
          Authorization: `Bearer ${this.getAccessToken()}`
        }
      };
      axios(config)
        .then((response) => {
          if (response.data.data) {
            resolve(response.data.data);
          } else {
            reject(response);
          }
        })
        .catch((error) => {
          reject(error);
        });
    });

  createLanguage = (data) =>
    new Promise((resolve, reject) => {
      const dataCreate = JSON.stringify(data);
      const config = {
        method: "post",
        url: `${API_ANNOUNCEMENT_URL}/language`,
        data: dataCreate,
        headers: {
          ...COMMON_HEADER_CONFIG,
          Authorization: `Bearer ${this.getAccessToken()}`
        }
      };
      axios(config)
        .then((response) => {
          if (response.data.data) {
            resolve(response.data.data);
          } else {
            reject(response);
          }
        })
        .catch((error) => {
          reject(error);
        });
    });

  updateLanguage = (data) =>
    new Promise((resolve, reject) => {
      const dataUpdate = JSON.stringify(data);
      const config = {
        method: "put",
        url: `${API_ANNOUNCEMENT_URL}/language/${data.id}`,
        data: dataUpdate,
        headers: {
          ...COMMON_HEADER_CONFIG,
          Authorization: `Bearer ${this.getAccessToken()}`
        }
      };
      axios(config)
        .then((response) => {
          if (response.data.data) {
            resolve(response.data.data);
          } else {
            reject(response);
          }
        })
        .catch((error) => {
          reject(error);
        });
    });

  deleteLanguage = (id) =>
    new Promise((resolve, reject) => {
      const config = {
        method: "delete",
        url: `${API_ANNOUNCEMENT_URL}/language/${id}`,
        headers: {
          ...COMMON_HEADER_CONFIG,
          Authorization: `Bearer ${this.getAccessToken()}`
        }
      };
      axios(config)
        .then((response) => {
          if (response.data) {
            resolve(response.data);
          } else {
            reject(response);
          }
        })
        .catch((error) => {
          reject(error);
        });
    });
}

const languageService = new LanguageService();

export default languageService;
